export const environment = {
  production: false,
  apiUrl: '__APIURL__',
  apiUrl2: '__APIURL2__',
  authConfig: {
    clientID: '__CLIENTID__',
    domain: '__DOMAIN__',
    responseType: 'token id_token',
    audience: '__AUDIENCE__',
    redirectUri: '__REDIRECTURL__',
    logoutUrl: '__LOGOUTURL__',
    scope: 'openid profile companyservice:access',
    inAppRedirects: {
      loggedIn: '/callback',
      error: '/error',
    },
  },
  serverHost: '__SERVERHOST__',
  chargifyPublicToken: '__CHARGIFYPUBLICTOKEN__',
  addressValidationEnvironmentURL: '__ADDRESSVALIDATIONENVIRONMENTURL__',
  profileConfig: {
    baseApiUrl: '__BASEAPIURL__',
    whitelist: '__WHITELIST__',
  },
  profileUrl: '__PROFILEURL__',
  resourceLink: '__RESOURCELINK__',
};
